//@ts-ignore
import ErrorPage, { PAGE_TYPES } from '@mindtickle/error-page';

const NoMatchingRoute = () => (
  <ErrorPage pageType={PAGE_TYPES.NOT_FOUND} showLogo={true} showGoToHome={true} />
);

export default NoMatchingRoute;
